<template>
    <el-dialog
            title="紧急联系人"
            :visible.sync="lianxiDialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="600px"
            center>
        <el-form :model="accountForm" :rules="rules" ref="accountForm" label-width="100px">
            <el-form-item label="姓名" prop="name">
                <el-input v-model="accountForm.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input v-model="accountForm.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item class="flex align-center justify-around" label-width="0">
                <el-button class="padding-lr-xl" @click="resetForm('accountForm')">取消</el-button>
                <el-button class="padding-lr-xl" type="primary" @click="submitForm('accountForm')">提交</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>

import rules from '@/utils/rules'
import {updateDeviceRoomDetail3} from "@/api/houst";

export default {
    name: "SafetyLianxiDialog",
    props: {
        lianxiDialog: {
            type: Boolean,
            default: false
        },
        lxrName: {
            type: String,
            default: ''
        },
        lxrPhone: {
            type: String,
            default: ''
        }
    },
    data() {

        return {
            power: 0,
            accountForm: {
                name: '',
                phone: '',

            },
            xiaoqu: [],
            rules: {
                name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
                phone: rules.phone,
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },

    },
    created() {

    },
    methods: {

        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$emit('cancelDialog', false)
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await updateDeviceRoomDetail3(
                this.$route.params.id,
                [this.accountForm.name,this.accountForm.phone].join('-')

            );
            this.$message.success(_state.info);
            this.$refs[formName].resetFields();
            this.$emit("cancelDialog", true);
        }

    },
    watch: {
        lxrName() {
            this.accountForm = {
                name: this.lxrName,
                phone: this.lxrPhone,
            };
        },
    }
}
</script>

<style scoped lang="scss">

</style>
